module.exports = __webpack_public_path__ + "media/images/porque/art-tax-f34d51aa48e0e566aa72f03eea98af54.svg";